import WorkingExpenseComponent from "../components/WorkingExpanse";
import useWorkingExpense from "../hooks/useWorkingExpanse";

const WorkingExpensePage = () => {
    const WorkingExpense = useWorkingExpense();
    return <WorkingExpenseComponent {...WorkingExpense} />;
};

export default WorkingExpensePage;
